import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
function ServiceLevelAgreementCustomerDialog(tabPage, parent) {
    var self = this;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogResult = ko.observable();
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.CustomerId() == null) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.Show = function (serviceLevelAgreementId, serviceLevelAgreementCustomerId) {
        tabPage.IsLoading(true);
        Bao.post("ServiceLevelAgreementTab/ShowServiceLevelAgreementCustomerDialog", JSON.stringify({
            sessionTabId: parent.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: serviceLevelAgreementId,
            serviceLevelAgreementCustomerId: serviceLevelAgreementCustomerId
        }), function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel);
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
}
export default ServiceLevelAgreementCustomerDialog;